import React from "react";

export default function Footer() {
  return (
    <footer>
      <span>Copyright &copy; 2021 All Rights Reserved : Abhishek Singh</span>
    </footer>
  );
}
